import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { successStories } from "@/mocks/successStories";
import SuccessStoryCard from "./components/SuccessStoryCard";
import RegistrationModal from "../home/components/RegistrationModal";
import BottomNav from "../home/components/BottomNav";
import WhatsAppButton from "../home/components/WhatsAppButton";

const FILTERS = [
  { id: "all", label: "הכל" },
  { id: "ליווי תעסוקתי", label: "ליווי תעסוקתי" },
  { id: "ליווי עסקי", label: "ליווי עסקי" },
  { id: "הכשרות מקצועיות", label: "הכשרות" },
];

export default function SuccessStoriesPage() {
  const navigate = useNavigate();
  const [activeFilter, setActiveFilter] = useState("all");
  const [modalOpen, setModalOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("activities");

  const filteredStories =
    activeFilter === "all"
      ? successStories
      : successStories.filter((s) => s.program === activeFilter);

  return (
    <div
      className="min-h-screen pb-24"
      style={{ background: "#FAF9F6", direction: "rtl" }}
      dir="rtl"
    >
      {/* Header */}
      <header className="sticky top-0 z-40 bg-white border-b-2 border-gray-900 px-4 py-3" dir="rtl">
        <div className="flex items-center gap-3">
          <button
            onClick={() => navigate("/")}
            className="w-10 h-10 flex items-center justify-center rounded-2xl border-2 border-gray-900 bg-white cursor-pointer hover:bg-gray-50 transition-colors flex-shrink-0"
            aria-label="חזרה"
          >
            <i className="ri-arrow-right-line text-xl text-gray-800"></i>
          </button>
          <div className="flex-1">
            <h1 className="text-lg font-black text-gray-900 leading-tight">
              סיפורי הצלחה
            </h1>
            <p className="text-xs font-medium text-gray-500">
              {successStories.length} סיפורים אמיתיים של משתתפים
            </p>
          </div>
        </div>
      </header>

      {/* Hero Banner */}
      <section className="mx-4 mt-4 rounded-3xl border-[3px] border-gray-900 overflow-hidden" dir="rtl">
        <div className="relative p-5" style={{ background: "#EDE9FE" }}>
          <div className="absolute -top-4 -right-4 w-20 h-20 rounded-full bg-purple-300 opacity-30"></div>
          <div className="absolute -bottom-4 -left-4 w-16 h-16 rounded-full bg-yellow-300 opacity-30"></div>

          <div className="relative z-10 flex items-center gap-3 mb-3">
            <div className="w-12 h-12 rounded-2xl border-[2.5px] border-gray-900 flex items-center justify-center flex-shrink-0" style={{ background: "#FDE68A" }}>
              <i className="ri-trophy-line text-gray-900 text-xl"></i>
            </div>
            <div>
              <h2 className="text-lg font-black text-gray-900 leading-tight">
                השינוי מתחיל כאן
              </h2>
              <p className="text-sm font-semibold text-gray-600">
                סיפורים אמיתיים של אנשים ששינו את חייהם
              </p>
            </div>
          </div>

          <div className="flex items-center gap-4">
            <div className="flex items-center gap-1.5">
              <span className="text-xl font-black text-gray-900">2,800+</span>
              <span className="text-xs font-semibold text-gray-600">משתתפים</span>
            </div>
            <div className="w-px h-6 bg-gray-400"></div>
            <div className="flex items-center gap-1.5">
              <span className="text-xl font-black text-gray-900">94%</span>
              <span className="text-xs font-semibold text-gray-600">שביעות רצון</span>
            </div>
          </div>
        </div>
      </section>

      {/* Filters */}
      <section className="px-4 pt-4 pb-2" dir="rtl">
        <div className="overflow-x-auto scrollbar-hide">
          <div className="flex gap-2" style={{ width: "max-content" }}>
            {FILTERS.map((filter) => {
              const isActive = activeFilter === filter.id;
              return (
                <button
                  key={filter.id}
                  onClick={() => setActiveFilter(filter.id)}
                  className="rounded-full px-4 py-2 text-sm font-bold border-[2px] cursor-pointer transition-all whitespace-nowrap"
                  style={{
                    background: isActive ? "#7C3AED" : "#FFFFFF",
                    borderColor: isActive ? "#7C3AED" : "#E5E7EB",
                    color: isActive ? "#FFFFFF" : "#4B5563",
                  }}
                >
                  {filter.label}
                </button>
              );
            })}
          </div>
        </div>
      </section>

      {/* Stories List */}
      <section className="px-4 pt-2 pb-4 flex flex-col gap-4" dir="rtl">
        {filteredStories.map((story) => (
          <SuccessStoryCard key={story.id} story={story} />
        ))}
      </section>

      {/* CTA Banner */}
      <section className="mx-4 my-4 rounded-3xl border-[3px] border-gray-900 overflow-hidden" dir="rtl">
        <div className="relative p-5" style={{ background: "#FEF9C3" }}>
          <div className="absolute -top-4 -right-4 w-16 h-16 rounded-full bg-yellow-300 opacity-40"></div>
          <div className="relative z-10">
            <h3 className="text-lg font-black text-gray-900 mb-1">
              רוצה להיות הסיפור הבא?
            </h3>
            <p className="text-sm font-medium text-gray-700 mb-3">
              הצטרף/י למתר והתחל/י את המסע שלך
            </p>
            <button
              onClick={() => setModalOpen(true)}
              className="bg-gray-900 text-white rounded-2xl px-6 py-2.5 text-sm font-black border-2 border-gray-900 hover:bg-gray-700 transition-colors cursor-pointer whitespace-nowrap"
            >
              הצטרף/י עכשיו
            </button>
          </div>
        </div>
      </section>

      {/* WhatsApp */}
      <WhatsAppButton />

      {/* Bottom Nav */}
      <BottomNav
        active={activeTab}
        onChange={(tab) => {
          setActiveTab(tab);
          if (tab === "home") navigate("/");
        }}
        onRegisterClick={() => setModalOpen(true)}
      />

      {/* Registration Modal */}
      <RegistrationModal isOpen={modalOpen} onClose={() => setModalOpen(false)} />
    </div>
  );
}
